<template>
  <div>

    <div>
      <div class="vuse-content-wrapper mt-4">
        <v-row >
          <v-col cols="12" md="6" class="mt-0">
            <h2 class="ml-3 float-left">
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="xmlReport">
                      <ExcelIcon />
                    </v-btn>
                  </template>
                  <span>Download Table as CSV</span>
                </v-tooltip>
              </span>
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="loadData">
                      <v-icon>sync</v-icon>
                    </v-btn>
                  </template>
                  <span>Refresh</span>
                </v-tooltip>
              </span>
             {{$t(page+'.Tables')}}
            </h2>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" class="mt-2">
            <v-card class="neu-glow pb-4">
              <v-card-title v-if="sendQuery==0">
                <v-row style="width:100%">
                  <v-col cols=12 sm="12" lg="12" v-if="selectedTable!=null" >
                      <v-btn x-small class="mr-1 success" @click="selectedTable=null">
                        <v-icon left>fas fa-table</v-icon>{{selectedTable}}
                      </v-btn>
                  </v-col>
                  <v-col cols=12 sm="12" lg="12" v-else >
                    <v-btn-toggle v-model="selectedTable" active-class="success" @change="refreshData">
                      <v-btn x-small color="indigo" dark v-for="table in tables" :key="table.tableName" class="mr-1 indigo lighten-2" :value="table.tableName">
                        <v-icon left>fas fa-table</v-icon>{{table.tableName}}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
                <v-row style="width:100%">
                  <v-col cols=12 sm="12" lg="12" >
                    <v-btn-toggle multiple v-model="selectedFields" active-class="success" @change="refreshData">
                      <v-btn x-small color="info" v-for="field in fields" :key="field.fieldName" class="mr-1" :value="field.fieldName">
                        <v-icon left>fas fa-columns</v-icon>{{field.fieldName}}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>                  
                </v-row>
                <v-row style="width:100%">
                  <v-col cols=12 sm="12" lg="12" >
                    <v-btn-toggle v-model="selectedWhereField" active-class="success" @change="refreshData">
                      <v-btn x-small color="indigo lighten-2" v-for="field in fields" :key="field.fieldName" class="mr-1" :value="field.fieldName">
                        <v-icon left>fas fa-filter</v-icon>{{field.fieldName}}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>                  
                </v-row>
                <v-row style="width:100%" class="mt-2" >
                  <v-col cols=12 sm="12" lg="9">
                    <v-text-field
                        outlined
                        v-model="query"
                        prepend-inner-icon="fas fa-search"
                        label="Query"
                        single-line
                        hide-details
                        background-color="red lighten-3"
                    ></v-text-field>
                  </v-col>
                  <v-col cols=12 sm="6" lg="2">
                    <v-text-field
                        outlined
                        v-model="whereValue"
                        prepend-inner-icon="fas fa-filter"
                        :label="$t(page+'.Where')"
                        single-line
                        hide-details
                        background-color="red lighten-3"
                    ></v-text-field>
                  </v-col> 
                  <v-col cols=12 sm="6" lg="1" >
                    <v-btn x-large color="success" class="ml-2" @click="Go">
                      <v-icon left>fas fa-cogs</v-icon>{{$t(page+'.Go')}}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-title v-else>
                <v-btn color="success" class="ml-2" @click="sendQuery=0">
                  <v-icon left>fas fa-cogs</v-icon>{{$t(page+'.Clear')}}
                </v-btn>
              </v-card-title>
              <v-data-table
                  dense
                  v-model="selectedRecord"
                  fixed-header="true"
                  :headers="headers"
                  :items="records"
                  :items-per-page=1000
                  :height="wIH - 362"
                  :search="search"
                  multi-sort
                  class="elevation-1 mx-4"
                  :loading="loading" 
                  :loading-text="$t(page+'.Loading... Please wait')"
                  :no-data-text="$t(page+'.Please select a Table')"
                  :no-results-text="$t(page+'.No Record matching search parameters')"
                >

              </v-data-table>
            </v-card>
          </v-col>
        </v-row>        
      </div>
    </div>
    <v-snackbar
      v-model="tables_snackbar"
      top
      width="550"
      color="#ff0000FA"
      timeout="-1"
      :multi-line="multiLine"
      style="margin-top:-64px;"
    >
      Leaving: Save?
    </v-snackbar>
  </div>
</template>
<style scoped>
  .bordered::before{
    border-color:transparent;
    border: 6px solid green!important;
  }
  .bottomborder::before{
    border-color:transparent;
    border-bottom: 8px solid blue!important;
  }
  .wrapped{
    height:60px!important;
    border-style:none!important;
  }
  .v-btn:before{
    background-color: inherit!important;
  }
  .v-btn--active:before{
    opacity:1!important;
  }
  .v-btn__content{
    display:block!important;
    }
  .v-btn-vertical{
    flex-direction: column!important;
  }
  .v-btn-toggle{
    display:inline-block!important;
  }
  .v-size--x-small{
    text-transform:none!important;
  }
  
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";

import _ from 'lodash'
export default {
  components: { NoData, SkeletonRevenue, ExcelIcon},
  computed : {
    ...mapGetters(["user","settings"]),
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
    query: function()
    {
      let q="SELECT "+(this.selectedFields.length==0?"*":this.selectedFields.join())+" FROM "+this.selectedTable+(this.selectedWhereField!=null&&this.whereValue.length!=0?" WHERE "+this.selectedWhereField + "='" + this.whereValue+"'":"");
      console.log(194,q);
      this.headers=[];
      this.selectedFields.forEach( e => {
        this.headers.push({"text": e,"value": e,"align":"start","class":"text-subtitle-1 font-weight-black primary--text py-2"})
        }
      )
      return q;
    }
  },    
  data() {
    return {
      namespace: "Reports",
      page: "BossTables",
      tables:null,
      fields: null,
      sendQuery:0,
      records:null,
      selectedTable:null,
      selectedFields:[],
      selectedRecord:null,
      selectedWhereField:null,
      whereValue:null,
      loading: true,
      tables_snackbar:false,
      search: '',
      changed:false,
      errorid: null,
      wIH:window.innerHeight,
      headers: [
          //{ text: '#', align: 'start', value: 'index', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          //{ text: 'Key', value: 'en',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'English', value: 'en',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Italiano', value: 'it',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Chinese', value: 'zh',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'}
      ],
    };
  },
  created(){
    this.loadData('Tables')
  },
  beforeDestroy() {
      console.log(167);
      this.localize_snackbar=true;
  },
  methods:
  {
    Go(){
      console.log(239,this.query)
      this.sendQuery=1;
      this.loadData('');
    },
    selectTable(t)
    {
      this.selectedTable=t;
      this.loadData(this.selectedTable);
    },

    edit(item,lang,t){
      this.changed=true;
      console.log(164,lang,item.en,t,this.selectedTable)
    },
    refreshData(){
     console.log(167,this.selectedTable);
      this.loadData(this.selectedTable);
    },
    async xmlReport(){
      let payload={"timeframe":this.timeframe.toString(),"sellers":this.activeeBayAccounts.toString()};
      window.location.href='/ajax/reports/revenue_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(table='Tables'){
      this.loading=true;
      try{
          const query=this.sendQuery==1?this.query:'';
          const payload={"action":"getTables","table":table,"query":query}
          const res = await this.$http.post('/boss/tables.php', payload );
          console.log(179,res)    
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              switch(table)
              {
                case 'Tables':
                  this.tables=res.data.payload;
                  console.log(219,this.tables)
                break;

                default:
                  if(this.query!=''&&this.sendQuery==1)
                  {
                    this.records=res.data.payload;
                    console.log(226,this.records)
                  }
                  else
                  {
                    this.fields=res.data.payload;
                    console.log(231,this.fields)
                  }
              }
              console.log(185,res.data.payload)
              this.loading= false;
            break;

            case '0001':

            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading=false;

      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }
      this.loading= false;
    }
  },
};
</script>
<!--<style scoped>
.theme--light.v-messages{
  display:none;
}
</style>-->